export const setSessionToken = sessionToken => async dispatch => {
  dispatch({ type: 'CREATE_SESSION', payload: sessionToken })
}

export const logOut = () => async dispatch => {
  dispatch({ type: 'CLEAR_SESSION', payload: '' })
}
